// extracted by mini-css-extract-plugin
export var footer = "_lj-5";
export var fulfillmentInput = "_lj-0";
export var shipDateInput = "_lj-1";
export var shipmentModal = "_lj-2";
export var shipmentModalContent = "_lj-3";
export var tableContainer = "_lj-4";